var getBaseUrl = function getBaseUrl() {
  var _window;
  var hostname = (_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.hostname;
  if (hostname !== null && hostname !== void 0 && hostname.includes('jira-dev.com') || hostname !== null && hostname !== void 0 && hostname.startsWith('trellis.coffee') || hostname !== null && hostname !== void 0 && hostname.startsWith('localhost') || hostname !== null && hostname !== void 0 && hostname.startsWith('team.stg')) {
    return 'https://trellis.coffee';
  }
  return 'https://trello.com';
};
export var viewAllLinkGenerator = function viewAllLinkGenerator(query) {
  return query ? "".concat(getBaseUrl(), "/search?q=").concat(encodeURIComponent(query)) : "".concat(getBaseUrl(), "/search");
};